import { useSyncExternalStore } from "react";
import axios from "axios";

// Store singleton (mesmo padrão de hostStatusStore.js) com polling de 60s.
// Usa axios puro: api.js/apiCliente.js redirecionam para /login sem token.
const POLL_INTERVAL_MS = 60000;

let cache = {
  blocked: false,
  motivo: null,
  whatsapp: "",
  email: "",
  carregado: false,
};
const listeners = new Set();
let inFlight = null;
let pollTimer = null;

const notify = () => listeners.forEach((listener) => listener());

const baseUrl = () =>
  `${
    window?.config?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL || ""
  }`;

// useSyncExternalStore exige a mesma referência quando nada mudou
const aplicarEstado = (novo) => {
  const mudou =
    cache.blocked !== novo.blocked ||
    cache.motivo !== novo.motivo ||
    cache.whatsapp !== novo.whatsapp ||
    cache.email !== novo.email ||
    cache.carregado !== novo.carregado;

  if (!mudou) return;

  cache = novo;
  notify();
};

const buscarStatus = () => {
  if (inFlight) return inFlight;

  inFlight = axios
    .get(`${baseUrl()}/system/status`, { withCredentials: false })
    .then(({ data }) => {
      aplicarEstado({
        blocked: data?.blocked === true,
        motivo: data?.motivo || null,
        whatsapp: data?.suporte?.whatsapp || "",
        email: data?.suporte?.email || "",
        carregado: true,
      });
    })
    .catch(() => {
      // fail-open: quem bloqueia de verdade é o backend
      aplicarEstado({ ...cache, carregado: true });
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
};

// Um único intervalo compartilhado enquanto houver ao menos um consumidor
const ensurePolling = () => {
  if (pollTimer) return;
  pollTimer = setInterval(buscarStatus, POLL_INTERVAL_MS);
};

const stopPolling = () => {
  if (!pollTimer) return;
  clearInterval(pollTimer);
  pollTimer = null;
};

export const subscribeSystemStatus = (listener) => {
  listeners.add(listener);
  if (listeners.size === 1) {
    buscarStatus();
    ensurePolling();
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) stopPolling();
  };
};

export const getSystemStatusSnapshot = () => cache;

// força releitura imediata (usado pelos logins após autenticar)
export const refreshSystemStatus = async () => {
  await buscarStatus();
  return cache;
};

export const useSystemStatus = () =>
  useSyncExternalStore(subscribeSystemStatus, getSystemStatusSnapshot);
